import Konva from 'konva'
import {useCallback, useEffect, useRef, useState} from 'react'

export function useResponsiveStageSize(
  stageRef: React.MutableRefObject<Konva.Stage>,
  stageContainerRef: React.MutableRefObject<HTMLElement>
) {
  const [stageSize, setStageSize] = useState({
    width: 550,
    height: 400,
  })

  const adjustStage = useCallback(() => {
    if (!stageRef.current || !stageContainerRef.current) {
      return
    }

    setStageSize({
      width: stageContainerRef.current.clientWidth,
      height: stageContainerRef.current.clientHeight,
    })
  }, [stageRef, stageContainerRef])

  useEffect(() => {
    const callback = adjustStage

    window.addEventListener('resize', callback)

    callback()

    return () => window.removeEventListener('resize', callback)
  }, [])

  return stageSize
}
